import ChangePhotoRequestRepository from '../../domain/repositories/ChangePhotoRequestRepository';
import ChangePhotoRequestDataStore from '../datastores/ChangePhotoRequestDataStore';
import ChangePhotoRequestDataStoreFactory from '../factories/ChangePhotoRequestDataStoreFactory';

export default class ChangePhotoRequestDataRepository
  implements ChangePhotoRequestRepository
{
  register(
    period: string,
    imgBase64: string,
    fileType: string,
    procedureId: number
  ) {
    const changePhotoRequestDataStore: ChangePhotoRequestDataStore =
      ChangePhotoRequestDataStoreFactory.create();
    return changePhotoRequestDataStore.register(
      period,
      imgBase64,
      fileType,
      procedureId
    );
  }

  cancel(requestId: number, procedureId: number) {
    const changePhotoRequestDataStore: ChangePhotoRequestDataStore =
      ChangePhotoRequestDataStoreFactory.create();
    return changePhotoRequestDataStore.cancel(requestId, procedureId);
  }
}
